import { CompletionTypes } from '../../../utils/postScoreConstants';
import { sportTypeIds } from '../../../utils/eventConstants';

export const MAX_SETS_ALLOWED = 3;
const POSITIONS_PER_SET = 2;

const createPositionScoreConfig = (setLabel, setIndex, positionNumber) => ({
    label: setLabel,
    id: `${setIndex}-${positionNumber}`,
    position: `pos${positionNumber}Score`,
    tieBreakPosition: `pos${positionNumber}TieBrk`,
});

export const getSetOptions = (sportTypeId = sportTypeIds.TENNIS) => {
    const labelPrefix = sportTypeId === sportTypeIds.TENNIS ? 'Set' : 'Game';

    return Array.from({ length: MAX_SETS_ALLOWED }, (_, setIndex) => {
        const setLabel = `${labelPrefix} ${setIndex + 1}`;
        return {
            id: setIndex,
            games: Array.from(
                { length: POSITIONS_PER_SET },
                (_, posIndex) => createPositionScoreConfig(setLabel, setIndex, posIndex + 1),
            ),
        };
    });
};

export const OUTCOME_OPTIONS = {
    COMPLETED: 'completed',
    INCOMPLETE: 'incomplete',
    RETIRED: 'retired',
    DEFAULTED: 'defaulted',
    WITHDREW: 'withdrew',
    FORFEIT: 'forfeit',
    ABANDONED: 'abandoned match',
    DOUBLEWALKOVER: 'double walkover',
};

export const OUTCOMES_TO_ALLOW_SCORING = [
    OUTCOME_OPTIONS.COMPLETED,
    OUTCOME_OPTIONS.INCOMPLETE,
    OUTCOME_OPTIONS.RETIRED,
    OUTCOME_OPTIONS.FORFEIT,
    OUTCOME_OPTIONS.ABANDONED,
    OUTCOME_OPTIONS.DEFAULTED,
];

export const OUTCOMES_WITH_WINNER_BY_SCORE = [
    OUTCOME_OPTIONS.COMPLETED,
];

export const OUTCOMES_WITH_WINNER_BY_TEAM_OR_PLAYER_SELECTOR = [
    OUTCOME_OPTIONS.WITHDREW,
    OUTCOME_OPTIONS.DEFAULTED,
    OUTCOME_OPTIONS.RETIRED,
    OUTCOME_OPTIONS.FORFEIT,
];

export const OUTCOMES_WITH_NO_WINNER = [
    OUTCOME_OPTIONS.INCOMPLETE,
    OUTCOME_OPTIONS.ABANDONED,
    OUTCOME_OPTIONS.DOUBLEWALKOVER,
];

export const OUTCOMES_TO_CONSIDER_AS_NOT_COMPLETED = [
    OUTCOME_OPTIONS.INCOMPLETE,
    OUTCOME_OPTIONS.ABANDONED,
];

export const getMatchOutComeFromCompletionType = (completionType, outcome = null) => {
    if (outcome) {
        return outcome === 'withdraw' ? 'withdrew' : outcome;
    }

    switch (completionType) {
        case CompletionTypes.WINNER_COMPLETED:
        case CompletionTypes.TIE_COMPLETED:
            return OUTCOME_OPTIONS.COMPLETED;
        case CompletionTypes.TIE_INCOMPLETE:
        case CompletionTypes.WINNER_INCOMPLETE:
            return OUTCOME_OPTIONS.INCOMPLETE;
        default:
            return outcome;
    }
};

export const PLAYER_OR_TEAM_SELECTOR = {
    retired: {
        label: 'retired',
        id: 'matchRetired',
    },
    defaulted: {
        label: 'defaulted',
        id: 'matchDefaulted',
    },
    withdrew: {
        label: 'withdrew',
        id: 'matchWithdrew',
    },
    forfeit: {
        label: 'forfeited',
        id: 'matchForfeit',
    },
};
